// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1dUmO","sendOtp":"AuthorizeToLogin_sendOtp__2hFtR"};